// extracted by mini-css-extract-plugin
export default {"ttl":"styles_ttl__XooQD","txt":"styles_txt__2Lozt","btnSec":"styles_btnSec__Po3CS","cancel":"styles_cancel__FkSmZ","submit":"styles_submit__LK7+J"};